import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const authenticateUser = async (payload) => {
    const payload2 = {
        username: payload.userId,
        password: payload.password
    }

    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/admin_login`,
        data: payload2,
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};